import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { Linked, useLinked } from "@type-r/react";
import { CollapsableSection, Column, Flex, asDateTime } from "lqx-react/lib";
import React from "react";
import { AssetTypesDisplay } from "../api/assetType";
import { ImportTemplateCard } from "../api/importTemplateCard";
import { HeaderTitle } from "../components/asset-details-pane-styles";
import { CopyRow } from "../components/copy-row";
import { DetailsPaneActionsContainer, DetailsPaneContainer, DetailsPaneHeader, DetailsPaneStatus, DetailsPaneTab, DetailsPaneTabContent, DetailsPaneTabs, colorStyles, detailsPanelStyles } from "../components/item-card-styles";
import { ImportTemplatesActions } from "./import-templates-actions";
import { ImportTemplateActivitiesTab } from "./activities-tab";

export const ImportTemplatesDetailsPane = ({ $activeCard, $selectedTab, onDelete }: { $activeCard: Linked<ImportTemplateCard>, $selectedTab: Linked<string>, onDelete: any }) => {

    const classes = detailsPanelStyles();
    const colorClasses = colorStyles();
    const importTemplateStatus = () => $activeCard && $activeCard.value.isActive ?
        <span className={colorClasses.active}>Active</span> : <span className={colorClasses.inactive}>Inactive</span>

    return (
        <>
            <DetailsPaneContainer>
                <DetailsPaneHeader>
                    <IconButton aria-label="Close" size="small" className={classes.iconButton} onClick={() => $activeCard.set(null)}>
                        <CloseIcon />
                    </IconButton>
                    <Flex alignCenter>
                        <DetailsPaneStatus>{importTemplateStatus()}</DetailsPaneStatus>
                    </Flex>
                    <Flex>
                        <HeaderTitle><>Import Template {$activeCard.value.id}</></HeaderTitle>
                    </Flex>
                </DetailsPaneHeader>
                <DetailsPaneActionsContainer>
                    <ImportTemplatesActions importTemplateCard={$activeCard.value} onDelete={onDelete} />
                </DetailsPaneActionsContainer>
                <DetailsPaneTabs value={$selectedTab.value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={(_, newValue) => $selectedTab.set(newValue)} >
                    <DetailsPaneTab value="details" label=" Details" />
                    <DetailsPaneTab value="activities" label="Activities" />
                </DetailsPaneTabs>
                <DetailsPaneTabContent>
                    {$selectedTab.value === 'details' && <Details classes={classes} importTemplateCard={$activeCard.value} />}
                    {$selectedTab.value === 'activities' && <ImportTemplateActivitiesTab importTemplateId={$activeCard.value.id} />}
                </DetailsPaneTabContent>
            </DetailsPaneContainer>
        </>
    )
};

const Details = ({ classes, importTemplateCard }: { classes: any, importTemplateCard: ImportTemplateCard }) => {
    return (
        <>
            <CollapsableSection title='General' titleClassName={classes.sectionTitle} noBorder noShadow >
                <Column>
                    <CopyRow label='Name' value={importTemplateCard.name} />
                    <CopyRow label='Companies' value={importTemplateCard.companies.map(company => company.name).join(', ')} />
                    <CopyRow label='Asset Types' value={AssetTypesDisplay[importTemplateCard.assetTypeId]} />
                    <CopyRow label='Created By' value={importTemplateCard.createdBy} />
                    <CopyRow label='Created On' value={asDateTime(importTemplateCard.createdOn)} />
                    <CopyRow label='Updated On' value={asDateTime(importTemplateCard.updatedOn)} />
                </Column>
            </CollapsableSection>
        </>
    )
}; 